import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  AdminMovieGroupIndexParams,
  AdminMovieGroupUpdateMovieTagsParams,
  AdminMovieGroupCollectionDestroyParams,
} from 'src/models/apis/movieGroup/adminMovieGroupRequest';
import {
  type AdminMovieGroupIndexResponse,
  type AdminMovieGroupResponse,
  type AdminMovieGroupUpdateMovieTagsResponseRaw,
  type AdminMovieGroupDestroyResponseRaw,
  type AdminMovieGroupCollectionDestroyResponse,
  toAdminMovieGroup,
  toAdminMovieGroupUpdateMovieTags,
  toAdminMovieGroupDestroy,
} from 'src/models/apis/movieGroup/adminMovieGroupResponse';
import type {
  AdminMovieGroup,
  AdminMovieGroupUpdateMovieTagsResponse,
  AdminMovieGroupDestroyResponse,
} from 'src/models/movieGroup';

export default {
  async adminIndex(params: AdminMovieGroupIndexParams): Promise<AdminMovieGroup[]> {
    const response = await api.get<AdminMovieGroupIndexResponse>(utils.getApiUrl('/admin/movie_groups'), { params });
    return response.data.map(toAdminMovieGroup);
  },
  async adminShow(id: number): Promise<AdminMovieGroup> {
    const response = await api.get<AdminMovieGroupResponse>(utils.getApiUrl(`/admin/movie_groups/${id}`));
    return toAdminMovieGroup(response.data);
  },
  async adminUpdateMovieTags(
    id: number,
    params: AdminMovieGroupUpdateMovieTagsParams,
  ): Promise<AdminMovieGroupUpdateMovieTagsResponse> {
    const response = await api.put<AdminMovieGroupUpdateMovieTagsResponseRaw>(
      utils.getApiUrl(`/admin/movie_groups/${id}/movie_tags`),
      params,
    );
    return toAdminMovieGroupUpdateMovieTags(response.data);
  },
  async adminDestroy(id: number): Promise<AdminMovieGroupDestroyResponse> {
    const response = await api.delete<AdminMovieGroupDestroyResponseRaw>(
      utils.getApiUrl(`/admin/movie_groups/${id}`),
    );
    return toAdminMovieGroupDestroy(response.data);
  },
  async adminCollectionDestroy(
    params: AdminMovieGroupCollectionDestroyParams,
  ): Promise<AdminMovieGroupDestroyResponse[]> {
    const response = await api.post<AdminMovieGroupCollectionDestroyResponse>(
      utils.getApiUrl(`/admin/movie_groups/collection`),
      params,
    );
    return response.data.map(toAdminMovieGroupDestroy);
  },
};
